import { render } from "./TradeDetails.vue?vue&type=template&id=22987df4&scoped=true"
import script from "./TradeDetails.vue?vue&type=script&lang=js"
export * from "./TradeDetails.vue?vue&type=script&lang=js"

import "./TradeDetails.vue?vue&type=style&index=0&id=22987df4&lang=scss&scoped=true"
import "./TradeDetails.vue?vue&type=style&index=1&id=22987df4&lang=scss"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22987df4"]])

export default __exports__